/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListGcpIamCredentialsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListGcpIamCredentialsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListGcpIamCredentialsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGcpIamCredentialsSecurity$outboundSchema: z.ZodMiniType<
  ListGcpIamCredentialsSecurity$Outbound,
  ListGcpIamCredentialsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listGcpIamCredentialsSecurityToJSON(
  listGcpIamCredentialsSecurity: ListGcpIamCredentialsSecurity,
): string {
  return JSON.stringify(
    ListGcpIamCredentialsSecurity$outboundSchema.parse(
      listGcpIamCredentialsSecurity,
    ),
  );
}

/** @internal */
export type ListGcpIamCredentialsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGcpIamCredentialsRequest$outboundSchema: z.ZodMiniType<
  ListGcpIamCredentialsRequest$Outbound,
  ListGcpIamCredentialsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listGcpIamCredentialsRequestToJSON(
  listGcpIamCredentialsRequest: ListGcpIamCredentialsRequest,
): string {
  return JSON.stringify(
    ListGcpIamCredentialsRequest$outboundSchema.parse(
      listGcpIamCredentialsRequest,
    ),
  );
}
